module.exports = __webpack_public_path__ + "static/lahli_spinach_rustica_morning_protein_bites_nutrition-a2f6f0c50bcd25c5be4f27c06186ad31.png";